'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import makeAsyncModal from 'DesignComponents/modals/makeAsyncModal';
import { FolderPropTypes } from 'DesignData/propTypes/finder';
const DeployFunctionWizard = makeAsyncModal(() => import(
/* webpackChunkName: "modals" */
'DesignFinderUI/components/modals/DeployFunctionWizard'));
export default function withDeployFunctionWizard(WrappedComponent) {
  class HighOrderWithDeployFunctionWizard extends Component {
    constructor(props) {
      super(props);

      this.componentDidUpdate = prevProps => {
        if (this.props.folderId !== prevProps.folderId) {
          this.setState({
            folderId: this.props.folderId
          });
        }
      };

      this.handleDeployFunctionCallback = () => {
        this.setState({
          open: false
        });
      };

      this.handleDeployFunctionClick = () => {
        this.setState({
          open: true
        });
      };

      this.renderDeployFunctionWizard = () => {
        if (!this.state.open) {
          return null;
        }

        return /*#__PURE__*/_jsx(DeployFunctionWizard, {
          callback: this.handleDeployFunctionCallback,
          folderId: this.state.folderId
        });
      };

      this.state = {
        open: false,
        folderId: props.folderId
      };
    }

    render() {
      const renderedDeployFunctionWizard = this.renderDeployFunctionWizard();
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props, {
        DeployFunctionWizard: renderedDeployFunctionWizard,
        onDeployFunctionClick: this.handleDeployFunctionClick
      }));
    }

  }

  HighOrderWithDeployFunctionWizard.propTypes = {
    folderId: FolderPropTypes.folderId
  };
  HighOrderWithDeployFunctionWizard.defaultProps = {
    folderId: null
  };
  return HighOrderWithDeployFunctionWizard;
}